export type Heading = {
  id: string;
  level: number;
  text: string;
};

export const extractHeadings = (html: string): Heading[] => {
  if (!html) return [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const headingElements = doc.querySelectorAll('h1, h2, h3, h4, h5, h6, p.title');

  const headings: Heading[] = [];
  headingElements.forEach((heading) => {
    const isTitle = heading.classList.contains('title');
    const id = heading.getAttribute('id') ?? (isTitle ? 'title' : '');
    if (!id) return;

    const level = isTitle ? 1 : Number(heading.tagName.charAt(1));
    const hashLink = heading.querySelector('a[aria-hidden="true"]');
    hashLink?.remove();
    const text = heading.textContent?.trim() ?? '';
    if (text) {
      headings.push({ id, level, text });
    }
  });

  return headings;
};
